import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/global.css';
import './styles/desktop.css';
import './styles/compact-page-headings.css';

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
